<template>
    <el-table 
        class="material-table"
        ref="tableRef"
        :class="{'no-fixed-table-height': !settingForm.fixedHeight }"
        :header-cell-style="{ background:'#e8eaec',color:'#333', padding: 0 }"
        :data="tableData"
        border
        style="width: 100%"
        :max-height="settingForm.fixedHeight?fixedTableHeight:null" 
        @sort-change="sortChange"
        :cell-style="{ padding: '4px 0' }"
         cell-class-name="sum-data cell-popover"
        :row-class-name="rowClassName"
    >
        <el-table-column
            v-for="(column, index) in headMapList"
            :key="column.field + index"
            :label="column.field_name"
            :prop="column.field"
            :fixed="column.fixed"
            :show-overflow-tooltip="showOverflow(column.field)"
            align="left"
            :sortable="column.sort? 'custom':undefined"
            :width="isIndex(column)?90 :165"
           
        >
            <template slot="header"> 
                <TableHeader :key="column.field + index" :column="column"  :is-index="isIndex(column)"/> 
            </template>
            <template slot-scope="{ row }"> 
                <template v-if="row.type === 'sum'">
                    <div class="sum-column">
                        {{
                            column.field!=='index'&& row[column.field] === row['index']?
                            "-" :
                            row[column.field]
                        }}
                    </div>
                </template>
                <template v-else>
                    <TableCell 
                        :key="row.id"
                        :prop="column.field" 
                        :column="column" 
                        :data="row"
                        :isScroll="isScroll"
                        :hasPreview="hasPreview"
                        :hasAddCondition="getHasAddCondition(column)"
                    >
                        {{ row[column.field] }}
                    </TableCell> 
                </template>
                
            </template>
        </el-table-column>
        <div slot="empty" class="mt50">
            <p class="tac">暂无数据</p>
            <p class="text-color-error tac nowrap">该页面仅展示媒体有素材投放的广告数据，各媒体之间指标定义存在差异，不建议跨媒体进行数据对比</p>
        </div>
    </el-table>
</template>

<script>
import TableHeader from './table-header.vue'
import TableCell from './table-cell.vue';
import { FROZEN_COL_TYPE, SORT_DATA_LIST, DIMENSION_PREVIEW_LIST, DIMENSION_NO_FILTER_LIST } from '../../constant'
// .includes(this.column.field)
import { validNum } from '@/utils/validate'
export default {
    props: [ 
        'headList', 'list', 
        'frozen', 'flatDimensionNames', 'sumData',
        'settingForm', 'fixedTableHeight'
    ],
    components: { TableHeader, TableCell },
    inject: ['getDimensionData', 'getFieldData', 'sortChange', 'global'],
    methods: {
      
    },
    data() {
        return {
            headMapList: [],
            scrollTimeOut: null,
            isScroll: false,
        }
    },
    computed: {
        tableData() {
            const list = this.global.materialData.list;
            return list;
        },
        hasPreview() {
            const names = this.headMapList.map(v=>v.field)
            return DIMENSION_PREVIEW_LIST.some(name=>names.includes(name))
        },
       
    },
    mounted() {
       

    },
    methods: {
        doLayout() {
            this.$nextTick(()=> {
                this.$refs.tableRef.doLayout();
            })
        },
        showOverflow(field) {
            return !DIMENSION_PREVIEW_LIST.includes(field)
        },
        getHasAddCondition(column) {
            const field = column.field;
            const fieldData = this.global.fieldData;
            const dimensionData = this.global.dimensionData;
            if ((DIMENSION_NO_FILTER_LIST.includes(field) || fieldData[field])) {
                return false
            };
            return !!dimensionData[field];
        },
         rowClassName({ row }) {
            const hasPreview = DIMENSION_PREVIEW_LIST.some(field=> (row[`${field}_thumbnail`] || '').length > 1);
           if (hasPreview) {
                return 'preview-height'
            }
            return ''
        },
        handleTableScroll({ scrollTop, scrollLeft }) {
            this.isScroll = true;
            this.scrollTimeOut&&clearTimeout(this.scrollTimeOut);
            this.scrollTimeOut = setTimeout(()=> {
                this.isScroll = false;
                this.scrollTimeOut = null;
            }, 500)
        },
        setHeadMapList() {
            if (!this.headList.length) {
                this.headMapList = []
                return;
            }
            const { num, type } =  this.frozen;
            const fieldData = this.getFieldData()
            this.headMapList = [
                {
                    "field": "index",
                    "field_name": "序号",
                    "type": 'index',
                    fixed: FROZEN_COL_TYPE.CUSTOM === type&&num===0 ? undefined : 'left'
                }
            ].concat(
                this.headList.map((v, i)=> {
                    return  { 
                        ...v,
                        fixed: this.isFixed(v, i),//固定
                        sort: SORT_DATA_LIST.includes(v.field) || fieldData[v.field],//排序
                    };
                })
            );
        },
        // 是否为序号列
        isIndex(col) {
            return col.type === 'index'
        },
        // 是否固定左侧
        isFixed(item, i) {
            const { num, type } =  this.frozen;
            if (FROZEN_COL_TYPE.ALL_DIMENSION === type) {
                if (this.flatDimensionNames[item.field]) {
                    return true
                }
            }
            if (FROZEN_COL_TYPE.CUSTOM === type) {
                if (i < num) {
                    return true;
                }
            };
           
            return false;
        }
    },
    watch: {
        frozen: {
            handler() {
               setTimeout(()=>this.$nextTick(this.setHeadMapList))
            },
            deep: true,
            immediate: true
        },
        list() {
            this.setHeadMapList();
           this.doLayout()
        },
    }
}
</script>

<style lang="scss" scoped>
.no-fixed-table-height{
    max-height: none!important;
}
.material-table {
    &::before {
        height: 0;
    }
    &::v-deep {
        .preview-height {
            height: 65px;
        }
        .sum-data:has(.sum-column){
            background-color: #dcdee2;
        }
    } 
    .sum-column {
        color: rgb(96, 98, 102);
        font-weight: bold;
    }
    &::v-deep.el-table--border .el-table__body .el-table__cell{
        border-right: 1px solid transparent;
    }
    &::v-deep .el-table__header th.el-table__cell{
        padding: 2px 0;
        background-color: #f8f8f9;
    }
    &::v-deep td.el-table__cell{
        border-bottom: 1px solid #f2f5fc!important;
    }
    &::v-deep .el-table--border .el-table__body td.el-table__cell{
        border-right: 1px solid transparent!important;
    }
    &::v-deep.el-table--border th.el-table__cell{
        border-right: 1px solid #d7dce7 !important;
    }
    &::v-deep.el-table--border .el-table__cell.gutter{
        border: none!important;
    }
    &::v-deep  .el-table__body-wrapper{
        background-color: #f8f8f9;
    }
    &::v-deep .el-table__header-wrapper{
        background-color: #f8f8f9;
    }
}
</style>